// extracted by mini-css-extract-plugin
module.exports = {"ImageWrapper":"CarouselImage_ImageWrapper__NfmS0","isLoaded":"CarouselImage_isLoaded__YwjPN","CarouselImage":"CarouselImage_CarouselImage__AXvSO"};